import b from 'b_';
import { eachMonthOfInterval, isSameMonth, setYear } from 'date-fns';
import { ArrowShortBold } from 'education-icons';
import { Button, Text } from 'platform-components';
import { UI_KIT_TEXT_TYPOGRAPHY } from 'platform-components/src/components/constants';
import React, { useState } from 'react';

import { formatDate } from 'utils/date/formatDate';

import './week-picker__year.scss';

interface Props {
    selectedMonth: Date;
    onSelectMonth: (month: Date) => void;
    minDate?: Date;
}

export const YearView = (props: Props) => {
    const { selectedMonth, onSelectMonth, minDate } = props;
    const [selectedYear, selectYear] = useState(selectedMonth.getFullYear());
    const months = eachMonthOfInterval({
        start: new Date(selectedYear, 0, 1),
        end: new Date(selectedYear, 11, 31),
    });

    const handlePrevYearClick = () => {
        selectYear(selectedYear - 1);
    };
    const handleNextYearClick = () => {
        selectYear(selectedYear + 1);
    };

    return (
        <>
            <div className="week-picker__controls">
                <Button
                    className="week-picker__prev-year"
                    disabled={selectedYear === minDate?.getFullYear()}
                    icon={<ArrowShortBold />}
                    onClick={handlePrevYearClick}
                    view={Button.VIEW.CLEAR}
                />
                <div className="week-picker__current-year">
                    <Text typography={UI_KIT_TEXT_TYPOGRAPHY.paragraphLMedium}>{selectedYear}</Text>
                </div>
                <Button
                    className="week-picker__next-year"
                    icon={<ArrowShortBold />}
                    onClick={handleNextYearClick}
                    view={Button.VIEW.CLEAR}
                />
            </div>
            <div className="week-picker__months">
                {months.map((month) => (
                    <Button
                        className={b('week-picker', 'month', {
                            selected: isSameMonth(month, selectedMonth),
                        })}
                        onClick={() => onSelectMonth(setYear(month, selectedYear))}
                        view={Button.VIEW.CLEAR}
                    >
                        {formatDate(month, 'LLLL')}
                    </Button>
                ))}
            </div>
        </>
    );
};
